<template>
  <v-container>
    <v-layout justify-center wrap>
      <v-flex xs12 sm12 md10 lg8>
        <Search
        @searchStarted="onSearchStarted"
        :searching="searching"
        :total="product_ids.length"
        :count_done="count"/>
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap>
      <v-flex xs12 sm12 md10 lg8 class="d-flex">
        <h4 v-if="updated_at != 'Empty Data'">Amazon Data Updated: {{updated_at}}</h4>
        <h4 v-else>{{updated_at}}</h4>
        <!-- <h3 v-if="this.items">{{this.items.length}} items out of {{product_ids.length}}</h3> -->
        <v-spacer></v-spacer>
        <v-select
          v-model="sort_by"
          :items="sort_bys"
          label="Sort by"
          solo style="max-width: 160px"
          v-if="processed_items.length && !searching"
        ></v-select>
        <v-select
          v-model="filter_by"
          :items="stock_filters"
          label="Filter by"
          solo class="ml-3" style="max-width: 160px"
          v-if="processed_items.length && !searching"
        ></v-select>
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap>
      <v-flex xs12 sm12 md10 lg8>
        <ProductItem v-for="(item, i) in processed_items" :key="i" :item="item" style="margin-bottom: 2px;"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Search from '../components/Search';
import ProductItem from '../components/ProductItem';

export default {
  components: {
    Search, ProductItem
  }, 
  data: () => ({
    searching: false,
    count: 0,

    product_ids: [],
    items: [],

    stock_filters: [
      'All',
      'In Stock',
      'Out of Stock',
      'Limited Stock',
    ],
    filter_by: '',
    sort_bys: [
      'None',
      'Rank',
      'Profit',
    ],
    sort_by: '',

    updated_at: '',

    product_type: '',
    pricing: '',
  }),
  created(){
    this.product_type = this.$route.meta.product_type;
    if(this.$route.path.includes("hobby-baby")
      || this.$route.path.includes("hobby-patiosports")
      || this.$route.path.includes("hobby-pets")){
      this.pricing = 'hobby';
    }
    axios.post('/search/datatable-info', {
      pricing: this.pricing
    })
    .then(response =>  {
      this.updated_at = response.data.updated_at;
    }).catch(error => {
      console.log(error)
    });
  },
  computed: {
    processed_items: function(){
      var self = this;
      var unfiltered_resutls = this.items.filter(function(item){
        return self.filter_by === '' || self.filter_by === 'All' || item.status === self.filter_by;
      });
      if(self.sort_by === 'Rank'){
        unfiltered_resutls.sort(function(a, b){
          return parseInt(a.amazon_rank) - parseInt(b.amazon_rank)
        });
      } else if(self.sort_by === 'Profit'){
        unfiltered_resutls.sort(function(a, b){
          return parseFloat(b.net_profit.replace('$', '')) - parseFloat(a.net_profit.replace('$', ''))
        })
      }
      return unfiltered_resutls;
    }
  },
  methods: {
    onSearchStarted(store_id){
      this.filter_by = '';
      this.sort_by = '';

      this.items.splice(0, this.product_ids.length)
      this.count = 0;
      this.searching = true;
      this.store_id = store_id;
      axios.post('/search/pro-baby/init', {
        product_type: this.product_type,
        store_id: this.store_id,
        pricing: this.pricing
      })
      .then(response =>  {
        this.product_ids = response.data.stores;
        for (var i = this.product_ids.length - 1; i >= 0; i--) {
          this.getStore(this.product_ids[i])
        }
      }).catch(error => {
        this.searching = false;
      });
    },
    async getStore(product){
      var self = this
      var upc = ("0" + product.upc).slice(-12);
      var url = "https://search.mobile.walmart.com/v1/products-by-code/UPC/" + upc + "?storeId=" + this.store_id;
      await axios.get(url)
      .then(response => {
        self.count++;
        if(self.count >= self.product_ids.length){
          self.searching = false;
        }
        var item_ = Object.assign({}, product)
        if(!response.data.data.inStore.inventory.status || !response.data.data.inStore.location.aisles[0]){
          return;
        }
        item_.thumbnailImageUrl = response.data.data.common.thumbnailImageUrl;
        if(!item_.thumbnailImageUrl)
          return
        item_.status = response.data.data.inStore.inventory.status;
        item_.aisles = response.data.data.inStore.location.aisles[0];
        self.items.push(item_)
      })
      .catch(error => {
        // console.log(error)
        var self = this
        self.count++;
        if(self.count >= self.product_ids.length){
          self.searching = false;
        }
      })
    },
  }
};
</script>
